import { environment } from "environments/environment";
export const DATOS_API =  {
  url: environment.url,
  urlConteos: environment.urlConteos,
  urlWcpExterno: environment.urlWcpExterno,
  urlConteosGcti: environment.urlConteosGcti,
  urlConteosInnmotion: environment.urlConteosInnmotion,
  urlSurveyAutologin: environment.urlSurveyAutologin,
  urlTableau: environment.urlTableau,
  urlTableauCovid: environment.urlTableauCovid,
  urlAssets: environment.urlAssets,
  urlAssetsFileServer: environment.urlAssetsFileServer,
  urlEncuestador: environment.urlEncuestador,
  urlFileManager: environment.urlFileManager,
  urlAnalisisExcel: environment.urlAnalisisExcel,
  urlSengridWebHook: environment.urlSengridWebHook,
  url4allExterno: environment.url4allExterno,
  urlLogos: environment.urlLogos,
  endpoints: {
    updateFlagCambios:'/api_empresa/updateFlagModalSections/',
    getNivelNotificacionCat:'/api_empresa/getCatLevelNotification/',
    descargaEncuestaV3:'/api_empresa/consultarEncuestaV3/',
    consultarRequerimientos:'/api_empresa/getCompaniesAndProducts/',
    getResultadosDemograficos:'/Collaborators/getCatConfigResults/',
    saveResultadosDemograficos:'/Collaborators/saveConfigResults',
    getResultadosDemograficosGuardados:'/Collaborators/getConfigResults/',
    updateVivoNotificacion:'/api_empresa/changeStatusNotification/',
    mensajeResultModal:'/api_empresa/getModalResults',
    getHerachical:'/Collaborators/getHerachicalJson/',
    saveHerachical:'/Collaborators/saveHerachicalJson/',
    getHerachicalGuardados:'/Collaborators/getHerachicalJsonProduct/',
    getLideresCerAsoci:'/Collaborators/get/leaders/',
    saveFechaEnvioInvitacion: '/api_empresa/programarEncuesta/saveFechasLeaderGo/',
    updateNameIcon:'/api_empresa/logo/updateMasterTable/',
    regenerateCertify:'/api_empresa/regenerateCertify',
    getHistoryEmailColab:'/api_empresa/getColaboradorEmailStatus/',
    getAutomatedAuditInfo:'/api_empresa/automatedAuditInfo/',
    getProjectManagerProduct:'/ProjectManager/Get/',
    getInfoEmailStatus:'/api_empresa/getSingleEstatusEmail/',
    postliberaciónCultureBrief:'/api_empresa/SurferWebApp_CultureAuditMarkFinished/',
    getSectoresNuevo:'/api_empresa/Sectores/',
    getSubSectoresNuevo:'/api_empresa/Subsectores/',
    uploadRawDataFile:'/api_empresa/UploadRawDataFile/',
    getMasterFileService:'/api_empresa/getMasterFileService/',
    getUrlWebComProfile:'/api_empresa/webCompanyProfile/',
    getUrlWebComProfileExterno:'/api_empresa/webCompanyProfileExt/',
    getdataWPC:'/api_empresa/getdataWPC/',
    getdataWPCExt:'/api_empresa/getdataWPCExt/',
    updateDataWPC:'/api_empresa/updateDataWPC/',
    getWebCompanyProfileVisibility:'/api_empresa/getWebCompanyProfileVisibility/',
    updateWebCompanyProfileVisibility:'/api_empresa/updateWebCompanyProfileVisibility/',
    getCertificateDate:'/api_empresa/getCertificateDate/',
    updateCertificateDate:'/api_empresa/updateCertificateDate/',
    getRankigRangeColab:'/api_empresa/CompanySize/',
    getControlEncuesta:'/api_empresa/getSurvey/',
    updateFlagControlSurvey:'/api_empresa/updateSurveyControl',
    getFlagSuccesGo:'/api_empresa/getFlagSuccesGo',
    deleteProductEmpresa:'/api_empresa/deleteProducts/',
    getDataInfoEmpresaExt:'/api_empresa/getDataEmpresa/',
    saveTemplatesNorma35:'/api_empresa/Norma35/saveTemplates/',
    getTemplatesNorma35:'/api_empresa/Norma35/getTemplate/',
    getCatalogoRangoColaboradores:'/api_empresa/CompanySize_v2/',
    getStatusEncuestasNormaV3: '/api_empresa/surveyStatus_vn35/',
    updateSurveyStatus_vn35: '/api_empresa/updateSurveyStatus_vn35/',
    enviarRecordaManuNormaV3: '/api_empresa/Norma35/enviarRecordatorioManualV2/',
    getIdiomasTemplateEmailRT:'/api_empresa/getEmailsTForype/',
    getCat_typeOfResults:'/api_empresa/cat_typeOfResults/',
    updateConfigVoiceSection:'/api_empresa/updateConfigVoiceSection/',
    getStatusDemographicsPdf:'/SurveyJson/getStatusDemographicsPdf/',
    setEnableDemographicsPdf:'/SurveyJson/enableDemographicsPdf/',
    resetSurvey:'/api_empresa/colaborador/resetSurvey/',
    saveJsonsSilverCert:'/SurveyJson/saveJsonsSilverCert/',
    saveDataResultsGoFlow:'/api_empresa/saveDataResultsGoFlow/',
    getDataResultsGoFlow:'/api_empresa/getDataResultsGoFlow/',
    saveDataResultsGoFlowSQL:'/api_empresa/saveDataResultsGoFlowSQL/',
    sendEmailHelpRT:'/api_empresa/sendEMailJP/',
    sendEmailHelpRTExter:'/api_empresa/sendEMailJPExt/',
    calendSurveys:'/api_empresa/SurveySchedule/',
    getCatBenchMark:'/api_empresa/CatBenchMark/',
    getMyBenchMarks:'/api_empresa/SurveyProduct/GetMyBenchMarks/',
    // SaveBenchMark:'/api_empresa/SurveyProduct/SaveBenchMark/',
    GuideLineWCP:'/api_empresa/GuideLine/',
    getBadgeWPC:'/api_empresa/Company/Badge/',
    getMarkCultureAudit:'/api_empresa/SurferWebApp_CultureAuditGetMarkAuth/',
    postMarkCultureAudit:'/api_empresa/SurferWebApp_CultureAuditMarkAuth/',
    getReportSurveyGeneric:'/Broker/getAllUsersAndCompanys/',
    SaveBenchMark:'/api_empresa/SurveyProduct/SaveBenchMark_V2/',
    deleteBenchMarkNoAplic:'/api_empresa/SurveyProduct/DeleteBenchmark/',
    updateProductResultsType:'/api_empresa/updateProduct/',
    jsonHomeConfiguration:'/api_empresa/Home_Configuration/',
    homeActiveProducts:'/api_empresa/Active_Products/',
    getproductConfirmData:'/api_empresa/getproductConfirmData/',
    postConfirmData:'/api_empresa/User/ConfirmData/',
    addProductv2:'/api_empresa/Productos/V2/',
    create_Infrastructure:'/api_empresa/Create_Infrastructure/',
    saveJsonProductVirtualSMS:'/api_empresa/saveJsonProductVirtualSMS/',
    swift:{
      signUpUser:'/Swift_Platform/User/SignUp',
      saveProductSwift:'/Swift_Platform/Product/Save/',
    },
    leaderGo:{
      saveLeadersBack:'/Collaborators/save/leaders/',
      getTemplateEmailEmpre:'/api_empresa/getCorreosLeaderGo/',
      actualizarMultiFlagLid:'/Collaborators/update/many/',
      actualizarOneFlagLid:'/Collaborators/update/one/',
      getLeaderSelected:'/Collaborators/get/selected/leaders/',
      saveTemplateEmailLeader:'/api_empresa/saveTemplateLeaderGo',
      sendEmailLeaderGo:'/api_empresa/sendMailsLeaderGo/',
    },
    actionGo:{
      saveTemplateEmailActionGo:'/api_empresa/saveTemplateActionGo',
      getLideresActionGo:'/Collaborators/get/leadersBy/survey/',
      saveLeadersAction:'/Collaborators/save/leadersBy/survey/',
      getLeadersAction:'/Collaborators/read/leadersBy/survey/',
      createUserActionGo:'/api_empresa/generate/users/actiongo/',
      getLangLeadersCertificar:'/api_empresa/distinctLanguages/',
      sendMailLeadersAction:'/api_empresa/sendMailsActionGo/',
      postUserStatusActionCGO:'/Collaborators/update/userStatus/',
    },

    certificar3:{
      seccionCrearEncuesta:{
        actualizarCustomShortURL:'/api_empresa/customShortURL/',
        limitCustomShortURL:'/api_empresa/customShortURL/getCaracterLimit',
        crearEncuestaCer3:'/api_empresa/SurveyProduct/addToSurvey/',
        getUserSeccionEspecial: '/api_empresa/specialSectionInDemoUsers/',
        reasignarSeccionesEspeciales: '/api_empresa/changeStatusSurveySection'
      },
      focusV3:{
        crearEncuestaFocus:'/api_empresa/SurveyProduct/save/',
        getEncuestasFocus:'/api_empresa/SurveyProduct/getAll/',
        deleteEncuestaFocus:'/api_empresa/Product/delete/',
      },
      seccionTemplate:{
        getPlantillaCatalogo:'/api_empresa/CatMasterSeccions/get',
        postActualizaTemplate:'/api_empresa/QuestionsHistorial/',
        getActualizaTemplate:'/api_empresa/QuestionsHistorial/',

      }
    },

    configuracionProducto:{
      getBanderasConfiguracion:'/api_empresa/getFlagsConfig/',
      actualizaBanderasConfiguracion:'/api_empresa/setFlagsConfig/',
      actualizaTextoCertificado: '/api_empresa/SurferWebApp_UpdateCertificationKey/',
      getTextoCertificado: '/api_empresa/SurferWebApp_GetCertificationKey/'
    },

    seccionesCatMaster: {
      getCatalogo: '/api_empresa/CatMaster/get/',
      getCatalogov2: '/api_empresa/CatMaster/get_v2/',
      getTemplatesCertV3: '/api_empresa/SurveyTemplate/getAll/',
      getTemplate: '/api_empresa/SurveyTemplate/get/',
      //cuestionario = copia del template base en el producto
      actualizaIdiomasCuestionario: '/api_empresa/SurveyProduct/updateWithLanguages/',
      getSeccionesCuestionario: '/api_empresa/SurveyProduct/get/',
      setSeccionesCuestionario: '/api_empresa/SurveyProduct/update/',
      saveCambiosTemplate: '/api_empresa/SurveyProduct/saveAs/',
      getPreguntaCatMaster: '/api_empresa/CatMaster/getOne/',
      setPreguntaCatMaster: '/api_empresa/CatMaster/update',
      savePreguntaCatMaster: '/api_empresa/CatMaster/save',
      buscaPreguntaCatMaster: '/api_empresa/CatMaster/search/',
      catalogos: {
        idiomas: '/api_empresa/getCatLanguages',
        respuestasReactivos: '/api_empresa/getCatAnswerStatement',
        datosForAll: '/api_empresa/getCat4all/',
        demograficos: '/api_empresa/CatDemographic/get'
      }
    },

    actualizarSurveyEstatus:'/api_empresa/updateSurveyStatus/',
    buscarCorreo:'/api_empresa/searchEmailCGO',
    buscarToken:'/api_empresa/searchToken/',
    updateUser_:'/api_empresa/usuarios/updatePassword',
    enviarCodigo:'/api_empresa/usuarios/updateProfile/',
    updateEndDate:'/api_empresa/updateSurvey/endDate',
    certificar2: {
      guardarUsuariosDemo:'/api_empresa/saveUsuariosTest/',
      seccionConfirmaEncuesta:{
        activarEstatus:'/api_empresa/openSurvey/',
        getEstatusEncuesta:'/api_empresa/getStatusSurvey/',
      },
      envioCorreo:{
        getEstatusEnvioCorreos:'/api_empresa/getSendMails/',
        actualizaEstatusEnvioCorreos:'/api_empresa/setSendMails/',
      },
      seccionCrearEncuesta:{
        asignacionUsuarioDemo:'/api_empresa/keyPiloto/',
      }
    },
    ////Actualizar Bandera update fecha cierre
    obtenerTotalColaboradores:'/api/progress/123',
    status_survey_getcolaboradores: '/api_empresa/buscarColaboradorSQL/',
    getCol_survey:'/api_empresa/getProgressService/',
    send_email:'/api_empresa/email/',
    send_emailfocus:'/api_empresa/emailFocus/',
    send_emailnorma:'/api_empresa/Norma35/eMailColaborador/',
    delete_answer:'/api_empresa/deleteAnswers/',
    getBanderasProrroga:'/api_empresa/getProrroga/',
    getBanderasPin:'/api_empresa/GetIsPin/',
    setPin:'/api_empresa/SetIsPin/',
    actualizaBanderasProrroga:'/api_empresa/updateProrroga/',
    // getEncuestasAct:'/api_empresa/surveyGetAll/', servicio anterior
    getEncuestasAct:'/api_empresa/auditoria/getCompanies/',
    getDatosEmpresaAuditoriaA:'/api_empresa/auditoria/getDataProduct',
    actualizaNombreEncuesta:'/api_empresa/editProduct/',
    login: '/api_login/login',
    user: '/api_login/user/',
    acortador: 'http://gptw.global/yourls-api.php',
    empresas: '/api_empresa/Empresas/',
    empresasEdit: '/api_empresa/Empresas/edit/',
    empresasGET: '/api_empresa/EmpresasGET/',
    getUsuarioEmpresa: '/api_empresa/usuarioEmpresa/',
    getInfoTI: '/api_empresa/infoResponsableTI/',
    usuRep: '/api_login/register',
    idiomasGuardados: '/api_empresa/Idiomas/',
    borrarIdioma: '/api_empresa/Borrar/Idioma/',
    productos: '/api_empresa/Productos/',
    getStatuses: '/api_empresa/Certificar/estatusGET/',
    getStatusPart: '/api_empresa/Certificar/estatus/paso/',
    guardaStatus: '/api_empresa/Certificar/estatus/',
    reiniciarCertificar:'/api_empresa/Certificar/reiniciar/',
    reiniciarMedir:'/api_empresa/Producto/reiniciar/',
    reiniciarPulse:'/api_empresa/PulseCheck/reiniciar/',
    reiniciarFocus:'/api_empresa/Encuesta/reiniciar/',
    guardaAdicional: '/api_empresa/Adicionales/',
    actualizaAdicional: '/api_empresa/Adicionales/Update/',
    getAllAdicionales: '/api_empresa/Adicional/get/all/',
    guardaOpcionRespuestaAdicional: '/api_empresa/Adicionales/opcion/add/',
    guardaTraduccionAdicional: '/api_empresa/TraduccionesAdicional/',
    getListaIdiomas: '/api_empresa/idiomasPlantilla/',
    DataStep5Guardados: '/api_empresa/Documentador/Seccion/add/',
    GetDataStep5: '/api_empresa/Documentador/Seccion/get/',
    guardaColaboradores: '/api_empresa/Colaboradores/',
    guardaColaboradoresEmpresa: '/Collaborators/save/',
    getColaboradoresEmpresaFocus: '/Collaborators/get/',
    deleteColaboradoresEmpresaFocus: '/Collaborators/delete/',
    getFiltersDemograFocus: '/Collaborators/get/fields/',
    getFiltersDemograKey: '/Collaborators/get/filters/',
    postColaboradoresFiltrados:'/Collaborators/filter/',
    getColaboradoresFast: '/api_empresa/Colaboradores/get/',
    getColaboradoresFull: '/api_empresa/Colaboradores/download/',
    getColaboradoresFullNew: '/Collaborators/download/',
    getCTFull: '/api_empresa/Norma35/CentrosTrabajo/getInfoCT/',
    borrarColaboradores: '/api_empresa/Colaboradores/delete/',
    cargaArchivo: '/api_empresa/archivo/upload/',
    getArchivos: '/api_empresa/archivos/',
    borraArchivo: '/api_empresa/archivo/delete/',
    productoGestor: '/api_empresa/Producto/drive/',
    getArchivosInstituto: '/api_empresa/instituto/archivos',
    getStatusModal: '/api_empresa/Certificar/mensaje/get/',
    updateStatusModal: '/api_empresa/Certificar/mensaje/update/',
    getBaderasEncuesta: '/api_empresa/requerimientos/get/',
    setBaderasEncuesta: '/api_empresa/requerimientos/update/',
    //certificarmailsending
    emailsend:'/api_empresa/MailSenderPreview/',
    pilotoSMTP: '/api_empresa/senderPreviewSMTP/',
    pilotoSMTPGen: '/api_empresa/previewSMTP/',
    sendreminder:'/api_empresa/sendRecordatorio/',
    getemailreminder:'/api_empresa/getRecordatoriosManuales/',
    manualReminderSMTP: '/api_empresa/manualReminder/',
    manualReminderSMTPCer3: '/api_empresa/manualSending2/',
    cierreManual: '/Collaborators/manualCloseProcess',

    getEncuesta:'/api_empresa/consultarEncuesta/',
    getEncuestaBylang:'/api_empresa/consultarEncuesta/',
    getEncuestaNorma:'/api_empresa/consultarEncuestaNorma/',
    getEncuestaNorma35:'/consultarEncuestaNorma/',

    //nuevos endpoints de idiomas

    getIdiomasGuardados: '/api_empresa/Idiomas/get/',
    reiniciaCertificar: '/api_empresa/Certificar/reiniciar/',
    reiniciaFechasSurvey: '/api_empresa/Certificar/borrarFechas/',
    getSeccionesCertificar: '/api_empresa/Certificar/secciones/get/',

    //endpoints de demograficos, para uso en Colaboradores
    getTiposDemograficos: '/api_empresa/Demograficos/all/',
    getDemograficosGuardados: '/api_empresa/Demograficos/traduccion/get/',
    getDemograficosGuardadosTmp: '/api_empresa/Demograficos/traduccion/get/',

    //endpoint parametros de tableau
    getParamsTableau: '/api_empresa/SurferWebApp_GetForm/',

    //endpoint parametros de tableau de covid
    getParamsTableauCovid: '/Broker/CompanyByUser',

    //get correos de resultados de cgo2
    getCGO2EmpresasResults: '/api_empresa/getCorreos',

    //guardar URL de Autologger de encuesta
    guardaUrlAutologSurvey: '/api_empresa/saveURL/',

    //obtiene url de ca 2
    getURLCA2: '/api_empresa/ca/urlCA/',

    //obtiene url de actiongo
    getURLACTGO: '/api_empresa/SurferWebApp_GetURLresults/',
    getURLACTGO_V2: '/api_empresa/SurferWebApp_GetURLresults_v2/',

    //obtiene url del successGo
    getURLSuccessGo: '/api_empresa/SurferWebApp_GetURLSuccessGo/',
    getURLSuccessGoV3: '/api_empresa/SurferWebApp_GetURLSuccessGoV3/',
    getURLSuccessGoV4: '/api_empresa/SurferWebApp_GetURLSuccessGoV4/',
    getGetURLSuccessGoGCTI:'/api_empresa/SurferWebApp_GetURLSuccessGoGCTI/',

    //get status de mantenimiento
    getMantenimiento: '/api_empresa/getMantenimiento',

    //obtiene datos del feedback
    getFeedback: '/api_empresa/getFeedback/',
    colaboradoresEncuesta:'/api_empresa/Norma35/Colaborador/getAll/',
    //endpoints gestor de archivos
    cloud: {
      getRaiz: '/Gestor/Carpeta/get/raiz/',
      getCarpeta: '/Gestor/Carpeta/get/',
      saveCarpeta: '/Gestor/Carpeta/save',
      saveArchivo: '/Gestor/Archivo/save',
      deleteCarpeta: '/Gestor/Carpeta/delete/',
      deleteArchivo: '/Gestor/Archivo/delete/',
      copyArchivo: '/Gestor/Archivo/copy',
      //NUEVOS SERVICIOS
      getArchivos: '/FileServer/ListFiles?path=',
      getCarpetas: '/FileServer/GetFolders/',
      guardaArchivo: '/FileServer/WriteFile',
      guardaCarpeta: '/FileServer/Mkdirs',
      borraArchivo: '/FileServer/DeleteFile',
      getArchivo: 'https://fileserver.culturalgo.com/ReadFile?path=',
      excelTI: '/FileServer/GenerateExcelTIZipFile'
    },

    //endpoints templates correos
    templateCorreo: {
      getTemplate: '/api_empresa/getTemplate/',
      empresaTemplate: '/api_empresa/empresaTemplate/',
      saveTemplate: '/api_empresa/saveTemplate',
      updateTemplate: '/api_empresa/updateTemplate',
      statusTemplate: '/api_empresa/noValidado/',
      updateTemplateValido: '/api_empresa/updateValidado/',
      getStatusEditor: '/api_empresa/getEditValidado/',
      setStatusEditor: '/api_empresa/editValidado/',
      getCierreActivo: '/api_empresa/getActualizarFechaCierre/',
      setCierreActivo: '/api_empresa/setActualizarFechaCierre/',
      /////validar encuestas Focus
      validacionRequeridaFocusArea:'/api_empresa/FocusArea/validacionFocus/',
      getvalidacionRequeridaFocusArea:'/api_empresa/FocusArea/getValidacion/',
    },

    //endpoints editor de encuesta
    editorEncuesta: {
      saveJsons: '/SurveyJson/SaveJsons/',
      getJsons: '/SurveyJson/Get/',
      getOneJson: '/SurveyJson/GetOne/',
      update: '/SurveyJson/Update/',
      getConfig: '/SurveyJson/Config/Get/',
      getOneConfig: '/SurveyJson/Config/GetOne/',
      updateConfig: '/SurveyJson/Config/Update/',
      getJsonLogos: '/api_empresa/logo/getJsonLogo/',
      updateJsonLogos: '/api_empresa/logo/updateJsonLogo/'
    },

    //endpoints editor broker
    editorBroker: {
      getJson: '/api_empresa/getJsonCGO/',
      update: '/api_empresa/UpdateJsonCGO/',
      getFlag: '/api_empresa/getFlagJsonCGO/',
      updateFlag: '/api_empresa/UpdateFlagJsonCGO/',
      correos: {
        get: '/api_empresa/getCorreosCGO/',
        update: '/api_empresa/updateCorreosCGO/'
      }
    },

    //endpoints 2fa
    autenticacion: {
      login: '/api_login/login',
      loginV2: '/api_login/loginV2',
      dosPasos: '/api_login/authentication',
      get2FAStatus: '/api_login/getUser/',
      set2FAStatus: '/api_login/updateFlagUser/',
      logout: '/api_login/logOut/'
    },

    //banderas
    flags: {
      setCertificar: '/api_empresa/setFlagsConfig/',
      getCertificar: '/api_empresa/getFlagsConfig/',
      setMedir: '/api_empresa/Medir/setFlagsConfig/',
      getMedir: '/api_empresa/Medir/getFlagsConfig/',
      setPulseCheck: '/api_empresa/PulseCheck/setFlagsConfig/',
      getPulseCheck: '/api_empresa/PulseCheck/getFlagsConfig/',
      setFocusArea: '/api_empresa/FocusArea/setFlagsConfig/',
      getFocusArea: '/api_empresa/FocusArea/getFlagsConfig/',
    },

    //avisos
    avisos: {
      setAviso: '/api_empresa/saveAvisos/',
      getAviso: '/api_empresa/getAvisos/'
    },

    //notiifcaciones
    notificaciones: {
      get: '/api_empresa/getNotificaciones',
      update: '/api_empresa/updateStatus/',
      getNotificacionesEmpresa:'/api_empresa/getAllNewHistorial/'
    },

    getCodeSurv: {
      save: '/api_empresa/saveUrlCode',
      get: '/api_empresa/getUrlCode/'
    },

    // master table
    getMasterTable: '/api_empresa/SurferWebApp_GetMasterTable/',

    //actualizar master table
    updateMasterTable: '/api_empresa/SurferWebApp_UpdateMasterTable',
    updateBenchMark: '/api_empresa/updateRankingRange/',

    //get logs sendgrid
    getLogEmails: '/api_empresa/getLogEmails',

    //GEt CA de CGO EXPRES
    getCultureAuditCGOX: '/CGOExpress/api/getCultureAudit/',

    //ENVIOS MANUALES
    envioManual: {
      getTipos: '/api_empresa/getTypesEmails/',
      enviarCorreos: '/api_empresa/manualSending'
    },

    //CHECK VERSION DE EXCEL COLABORADORES
    versionExcel: {
      get: '/api_empresa/getCatExcel/',
      set: '/api_empresa/updateCatExcel'
    },

    //SET TIPO RESULTADOS SUCCESSGO
    setVersionSGO: '/api_empresa/updateFlagVersionSuccessGo/',

    //GET CONFIGURACIONES BROKERS
    brokerConfig: '/api_empresa/getCatBrokerConfiguration',

    //AUDITORIA MANUAL
    auditManual: {
      get: '/api_empresa/getSurveyManualAudit/',
      set: '/api_empresa/updateSurveyManualAudit/'
    },

    //CODIGO QR URL ENCUESTA
    surveyUrlQR: '/SurveyJson/GenerateCodeQrSurvey/',

    //ANALISIS DE EXCEL COLABORADORES
    analisisExcel: {
      enviarBD: '/api_excel/list_analysis'
    },

    //GET CHANGELOG
    getChangelog: '/Cgo_Version/Get',

    //BLOQUEAR RESULTADOS
    bloqueoResultados: {
      get: '/api_empresa/SurferWebApp_GetBlockedResults/',
      set: '/api_empresa/SurferWebApp_setBlockedResults'
    },

    //GET PAISES DE INSTITUTO (SEDE)
    getPaisesBroker: '/api_empresa/BrokerCountries/',

    //GET TOKEN KNOWLEDGEBASE
    loginKB: '/api_login/loginKB',
    loginLeaderGo: '/api_login/loginLeaderGO',

    //GENERAR AUDIO DE UN TEXTO
    tts: '/api_empresa/textToSpeech',
    linkMp3: '/api_empresa/SurveyProduct/GenerateAudioFile',
    getVoices: '/api_empresa/catVoices/getVoices/',
    saveFormVoices: '/api_empresa/catVoices/saveFormVoices/',
    getFormVoices: '/api_empresa/catVoices/getFormVoices/',
    saveQuestionAudio: '/api_empresa/SurveyProduct/SaveQuestionAudio',
    updateWithAudios: '/api_empresa/SurveyProduct/UpdateWithAudios',
    getQuestionAudio: '/api_empresa/SurveyProduct/GetQuestionAudio',

    //SECCIONES ESPECIALES
    getSeccionesSurvey: '/api_empresa/getSectionsSurvey/',
    setSeccionesEspeciales: '/api_empresa/personalizationSectionUser/',
    setPreguntasEspeciales: '/api_empresa/SurveyProduct/addSpecialQuestions/',

    //CONSULTA DE ENCUESTAS POR BROKER
    getMasterFileService_v2: '/api_empresa/getMasterFileService_v2/',
    getMasterFileService_v3: '/api_empresa/getMasterFileService_v3/',

    //CANCELAR ENVIO CORREOS
    cancelarEnvios: '/api_empresa/cancelSendMail/',

    //Get tabla Rawdata
    getRawDatas: '/api_empresa/SurferWebApp_GetRawDatas/',

    //info de empresa para confirmar
    getInfoEmpresaConfirmacion: '/api_empresa/SurferWebApp_AllCompanyInfo/',

    //asociar culture brief a producto
    asociarCultureBrief: '/api_empresa/ca/asociarCA/',

    //endpoints requerimientos tecnicos
    reqTec: {
      update: '/api_empresa/updatePasosReq/',
      get: '/api_empresa/getPasosReq/'
    },
    avanceEncuesta: {
      consultarUusuario:'/api_empresa/consultarColaboradores/',
      statussurvey:'/api_empresa/consultarEstatus/',
      statussurveyNorma:'/api_empresa/consultarEstatusN35/',
      downloadCol:'/api_empresa/consultarColaboradoresSQL/',
      getCatalogos:'/api_empresa/catalogoExcel/',
      catPaises: '/api_empresa/cat_paises/'
    },
    addColabsSurvey: {
      save: '/api_empresa/saveColaboradores/',
      buscaOwnkey: '/api_empresa/buscarOwnKey/',
      buscaBossKey: '/api_empresa/buscarBossKey/',
      buscarSurveyKey: '/api_empresa/buscarSurveyKey/',
      buscarColaboradorPassword: '/api_empresa/colaboradorByPassword/',

      getSetDelColaborador: '/api_empresa/colaborador/',
      buscaEmail: '/api_empresa/searchEmail/',
      getinfoxColabarador: '/api_empresa/colaboradorByName/',
      //usados en focus
      save_fa: '/Collaborators/saveOne/',
      update_fa: '/Collaborators/update/',
    },

    // Agregar colaboradores a encuesta
    urlColaboradores: '/api_empresa/Norma35/saveNomURL/',
    getUrlColaboradores:'/api_empresa/Norma35/geturlCentros/',

    //endpoints medir
    medirGenerico:{

      saveReactivos:'/api_empresa/saveReactivos/',
      saveControl:     '/api_empresa/saveControl/',
      saveDemograficos:'/api_empresa/saveDemograficos/',
      saveAdicionales: '/api_empresa/saveAdicionales/',
      saveAbiertas: '/api_empresa/saveAbiertas/',
      saveForall:  '/api_empresa/saveForall/',
      saveNPSCONTROL:'/api_empresa/savePreguntas/' // ES de prueba
    },
    medir: {
      getListaIdiomas: '/api_empresa/Medir/idiomasPlantilla/',
      getStatuses: '/api_empresa/Medir/estatusGET/',
      getStatusPart: '/api_empresa/Medir/estatus/paso/',
      guardaStatus: '/api_empresa/Medir/estatus/',
      getIdiomasGuardados: '/api_empresa/Medir/Idiomas/get/',
      guardaAdicional: '/api_empresa/Medir/Adicionales/',
      actualizaAdicional: '/api_empresa/Medir/Adicionales/Update/',
      getAllAdicionales: '/api_empresa/Medir/Adicional/get/all/',
      guardaOpcionRespuestaAdicional: '/api_empresa/Medir/Adicionales/opcion/add/',
      guardaTraduccionAdicional: '/api_empresa/Medir/TraduccionesAdicional/',
      getColaboradoresFast: '/api_empresa/Medir/Colaboradores/get/',
      borrarColaboradores: '/api_empresa/Medir/Colaboradores/delete/',
      guardaColaboradores: '/api_empresa/Medir/Colaboradores/',
      getColaboradoresFull: '/api_empresa/Medir/Colaboradores/download/',
      getStatusModal: '/api_empresa/Medir/mensaje/get/',
      updateStatusModal: '/api_empresa/Medir/mensaje/update/',
      emailsend:'/api_empresa/Medir/MailSenderPreview/',
      sendreminderMedir:'/api_empresa/Medir/sendRecordatorio/',
      sendreminderMedirGenerico:'/api_empresa/Medir/sendRecordatorio/',
      getMedirGenerico:'/api_empresa/getRecordatoriosManuales/',

      shedule:{
        guardaFechas:'/api_empresa/Medir/programarEncuesta/',
        postCrearEnc: '/api_empresa/Medir/crearEncuesta/',
        getFechaLanzamiento: '/api_empresa/programarEncuesta/fechaLanzamiento/',
        getRecordatorios: '/api_empresa/programarEncuesta/recordatorios/',
        obtieneFechas: '/api_empresa/Medir/programarEncuesta/fechas/',
        saveUsuarios: '/api_empresa/Medir/saveUsuarios/',
        saveReactivos: '/api_empresa/Medir/saveReactivos/',
        saveControl:     '/api_empresa/saveControl/',
        saveControl2:     '/api_empresa/Medir/saveControl/',
        getEstatusEncuesta: '/api_empresa/Medir/getEstatusEncuesta/',
        saveDemograficos:'/api_empresa/Medir/saveDemograficos/', // Prueba
        saveAdicionales: '/api_empresa/saveAdicionales/', // Prueba

        saveAbiertas: '/api_empresa/saveAbiertas/', // Prueba
        saveForall:  '/api_empresa/saveForall/', // Prueba
      },
      //APIS EnvioCorreo
      envioCorreo:{
        sendMail: '/api_empresa/Medir/MailSender/',
        getPilotoData: '/api_empresa/Medir/getPiloto/',
      },
      //APIS Cierre
      cierre:{
        getAvanceEncuesta: '/api_empresa/Medir/getAvanceEncuesta/',
        setCierre: '/api_empresa/Medir/terminar/',
      },
    },

    pulse:{
      statusPaso: '/api_empresa/PulseCheck/estatusGET/',
      guardaStatus: '/api_empresa/PulseCheck/estatus/',
      getStatusPart:'/api_empresa/PulseCheck/estatus/paso/',
      getIdiomasGuardados: '/api_empresa/PulseCheck/Idiomas/get/',
      getListaIdiomas: '/api_empresa/PulseCheck/idiomasPlantilla/',
      // APIS Colaboradores
      guardaColaboradores: '/api_empresa/PulseCheck/Colaboradores/',
      getColaboradoresFast: '/api_empresa/PulseCheck/Colaboradores/get/',
      getColaboradoresFull: '/api_empresa/PulseCheck/Colaboradores/download/',
      borrarColaboradores: '/api_empresa/PulseCheck/Colaboradores/delete/',

      //APIS Shedule
      getFecha:'/api_empresa/PulseCheck/get/fechas/', //productoId
      agregaFechas:'/api_empresa/PulseCheck/add/fechas/',//productoId,numeroFecha,fecha
      getRecordatoriosPulseManuales:'/api_empresa/PulseCheck/getRecordatoriosManuales/',
      sendRecordatoriosPulse:'/api_empresa/PulseCheck/sendRecordatorio/',
      guardaRecordatoriosPulse:'/api_empresa/PulseCheck/recordatorio/fechas/',
      getRecordatoriosPulseLanzamiento:'/api_empresa/PulseCheck/fechasRecordatorio/',

      ///APIS CrearEncuesta
      saveUsuarios:'/api_empresa/PulseCheck/saveUsuarios/',
      postCrearEnc: '/api_empresa/PulseCheck/crearEncuesta/',
      saveReactivos:'/api_empresa/PulseCheck/saveReactivos/',
      saveControl:  '/api_empresa/PulseCheck/saveControl/',
      getEncuetasPulsePiloto:'/api_empresa/PulseCheck/encuestas/get/',

      //APIS Envio de Correos
      envioCorreo: '/api_empresa/PulseCheck/MailSenderPreview/',
      getStatusModal: '/api_empresa/PulseCheck/mensaje/get/',
      updateStatusModal: '/api_empresa/PulseCheck/mensaje/update/',
      //progress bar

      getProgressEnc: '/api_empresa/PulseCheck/getEstatusEncuesta/',
      sendMail: '/api_empresa/PulseCheck/MailSender/',
      getAvanceEncuestaPulse: '/api_empresa/PulseCheck/getAvanceEncuesta/',
    },
    //FocusArea
    Focus:{
      getStatuses: '/api_empresa/FocusArea/estatusGET/',
      getStatusPart: '/api_empresa/FocusArea/estatus/paso/',
      guardaStatus: '/api_empresa/FocusArea/estatus/',
      getStatusModal: '/api_empresa/FocusArea/mensaje/get/',
      updateStatusModal: '/api_empresa/FocusArea/mensaje/update/',
      /// get lista encuesta:
      getEncuestas:'/api_empresa/FocusArea/encuesta/all/',
      /// agregar  encuesta:
      addEncuesta:'/api_empresa/FocusArea/encuesta/add/',
      /// Eliminar encuesta:
      deleteEncuesta:'/api_empresa/FocusArea/encuesta/delete/',

      ///Servicios Idiomas
      getIdiomasPlantilla:'/api_empresa/FocusArea/IdiomasPlantilla',
      getListaIdiomasFocus: '/api_empresa/FocusArea/Idiomas/get/', ///idiomas guardados
      saveIdeomasFocus: '/api_empresa/FocusArea/Idiomas/save/',
      deleteIdiomasFocus:'/api_empresa/FocusArea/Idiomas/delete/',
      ///Servcios Reactivos
      getPreguntasReactivos:'/api_empresa/FocusArea/getPreguntas/',
      savePreguntasReactivos:'/api_empresa/FocusArea/savePreguntas/',

      //Adicionales
      addAdicionales:'/api_empresa/FocusArea/addPregunta/',//"empresaId","tipoRespuesta" : 1,"seccion" : 1,"orden" : 1,"pregunta" : "¿El Andrés te pide un chingo de servicios?","requerido" :1
      getPreguntasAdiocnales:'/api_empresa/FocusArea/getPreguntas/',//"empresaId" : "5e29c354dbc34f0ee8f41f0f","seccion" : 2
      addOpcionTipoPregunta: '/api_empresa/FocusArea/addOpcion/',//"preguntaId": "5e3238c5cbeb7a365c821c61","orden" : 1,"respuesta" : "Simón"
      updatePreguntaAdicionales: '/api_empresa/FocusArea/updatePregunta/',
      updatePreguntaAdicionalTraduccion: '/api_empresa/FocusArea/updateTraduccion/',

      deletePreguntaFocus:'/api_empresa/FocusArea/deletePregunta/',//empresaId" : "5e29c354dbc34f0ee8f41f0f","preguntaId" : "5e3b25b716d2a5267437c1d1"
      deleteOpcionPreguntaFocus:'/api_empresa/FocusArea/deleteOpcion/',//empresaId" : "5e29c354dbc34f0ee8f41f0f","preguntaId" : "5e3b25b716d2a5267437c1d1"
      getTraduccionesAdicionalesFocus:'/api_empresa/FocusArea/getTraducciones/', //empresaId seccionId.
      saveTraduccionesAdicionalesFocus:'/api_empresa/FocusArea/saveTraduccion/',
      getPreguntasAdiocnalesAdmin:'/api_empresa/FocusArea/getPreguntas/',
      getTraduccionesAdicionalesFocusAdmin:'/api_empresa/FocusArea/getTraducciones/', //empresaId seccionId.
      actualizaBanderaEncuesta:'/api_empresa/FocusArea/updateVerificacion/',
      getActualizaBanderaEncuesta:'/api_empresa/FocusArea/getVerificacion/',
      updateValorOpcion:'/api_empresa/FocusArea/updateValor/',



      ///Colaboradores
      getColaboradoresFast:'/api_empresa/FocusArea/getColaboradores/',
      getInfoColaboradoresFull:'/api_empresa/FocusArea/getInfoColaboradores/',
      borrarColaboradores:'/api_empresa/FocusArea/deleteColaboradores/',
      guardaColaboradores:'/api_empresa/FocusArea/saveBdColaboradores/',

      ///CrearGrupoFocus
      crearGrupoFocus:'/api_empresa/FocusArea/grupo/',
      deleteGrupoFocus:'/api_empresa/FocusArea/deleteGrupo/',
      getGruposFocus:'/api_empresa/FocusArea/getGrupos/',
      actualizarGrupoFocus:'/api_empresa/FocusArea/editGrupo/',
      getInfoGrupoFocus:'/api_empresa/FocusArea/getGrupo/',
      getFiltrosGruposFocus: '/api_empresa/FocusArea/getFiltros/',

      // Programacion encuestas
      getFechasLanzamientoFocus:'/api_empresa/FocusArea/fechas/get/',
      guardaFechasLanzamientoFocus:'/api_empresa/FocusArea/programarEncuesta/',
      postCrearEnc:'/api_empresa/FocusArea/crearEncuesta/',
      saveUsuarios:'/api_empresa/FocusArea/saveUsuarios/',
      saveReactivos: '/api_empresa/FocusArea/saveReactivos/',
      getBaderasEncuestaFocus:'/api_empresa/requerimientos/get/',
      updateRequerimientosFocus:'/api_empresa/requerimientos/update/',
      getEstatusEncuestaFocus:'/api_empresa/FocusArea/getEstatusEncuesta/',
      getEncuestaPilotoFocus:'/api_empresa/FocusArea/getPiloto/',
      saveDemograficos:'/api_empresa/PulseCheck/saveDemograficos/',

      // envio correo
      sendMail:'/api_empresa/FocusArea/MailSender/',
      pilotmails:'/api_empresa/FocusArea/MailSenderPreview/',


      // cierre
      sendreminder:'/api_empresa/FocusArea/sendRecordatorio/',
      getAvanceEncuestaFocusArea:'/api_empresa/FocusArea/getAvanceEncuesta/',
      sendRecordatoriosFocusAreaManuales:'/api_empresa/FocusArea/sendRecordatorio/',
      getRecordatoriosFocusAreaManuales:'/api_empresa/FocusArea/getRecordatoriosManuales/',








      //reactivos
      reactivos: {
        getPlantillas: '/api_empresa/FocusArea/getDatosPlantilla/',
        getReactivos: '/api_empresa/FocusArea/getReactivosPlantilla/',
        getGuardados: '/api_empresa/FocusArea/getPreguntas/',
        guardaReactivo: '/api_empresa/FocusArea/addPregunta/',
        borraReactivo: '/api_empresa/FocusArea/deletePregunta/',

      }
    },

    logoEmpresa: '/api_empresa/logo/upload/',
    getLogoEmpresa: '/api_empresa/logo/get/',

    forAll:{
      getInstituto: '/api_empresa/Institutos',
      postStatements: '/api_empresa/Forall/statements/',
      postForallGet: '/api_empresa/ForallGET/',
      postGuardar: '/api_empresa/Forall/Guardar/',
      postCambiarOrden: '/api_empresa/Forall/cambiarOrden/',
      //APIS tranlate
      getLanguajesListNon3: '/api_empresa/Idiomas/all/',
      getLanguajesListSelected: '/api_empresa/Idiomas/agregados/',
      getTraducciones: '/api_empresa/Forall/Traducciones/',
      insertTranslate:'/api_empresa/Forall/Guardar/Traduccion/',

    },
    //APIS Demograficos
    demograficos:{
      getDemographics: '/api_empresa/Demograficos/',
      insertTraduccion: '/api_empresa/Demograficos/traducciones/',
      addResponse: '/api_empresa/Demograficos/Guardar/Opcion/',
      setBanderaDemograficos: '/api_empresa/Demograficos/Guardar/Bandera/',
      saveNewDemografico: '/api_empresa/Demograficos/Agregar/',
      guardarDemograficos: '/api_empresa/Demograficos/Guardar/',
      catalogoDemograficos: '/api_empresa/Demograficos/Catalogo/',
      deleteDemografico: '/api_empresa/Demograficos/Eliminar/',
      getBanderaDemograficos: '/api_empresa/Demograficos/Bandera/',
      obtenerDemograficos: '/api_empresa/Demograficos/traducciones/get/',
      saveQuestionTranslate: '/api_empresa/Demograficos/Guardar/Traduccion/',
      saveOpcionTranslate: '/api_empresa/Demogradicos/Guardar/Opcion/Traduccion/',
      updateDemographicData: '/api_empresa/Demograficos/update/',
      addquestion: '/api_empresa/addDemografico/',
      setCierre: '/api_empresa/Certificar/terminar/',
      deleteRespuestaDemografico:'/api_empresa/Demograficos/deleteOpcion/',

    },
    //APIS Shedule
    shedule:{
      postProgramarEnc:'/api_empresa/programarEncuesta/',
      postProgramarEnc2:'/api_empresa/programarEncuesta/saveFechas/',
      postCrearEnc: '/api_empresa/crearEncuesta/',
      postCrearEnc2: '/api_empresa/crearEncuesta2/',
      postCrearEnc3: '/SurveyJson/CreateSurvey/',
      getFechaLanzamiento: '/api_empresa/programarEncuesta/fechaLanzamiento/',
      getRecordatorios: '/api_empresa/programarEncuesta/recordatorios/',
      saveUsuarios: '/api_empresa/saveUsuarios/',
      applyUsuarios: '/api_empresa/applyUsuarios/',
      saveNPS:      '/api_empresa/saveNPS/',
      saveReactivos: '/api_empresa/saveReactivos/',
      saveControl:     '/api_empresa/saveControl/',
      saveDemograficos:'/api_empresa/saveDemograficos/',
      saveAdicionales: '/api_empresa/saveAdicionales/',
      saveAbiertas: '/api_empresa/saveAbiertas/',
      saveForall:  '/api_empresa/saveForall/',
      getEstatusEncuesta: '/api_empresa/getEstatusEncuesta/',
      getEstatusEncuesta2: '/api_empresa/getEstatusEncuesta2/',
      guardarLinkEncuesta:'/Encuestador/generateLink/',
      getEstatusBanderaEncuesta:'/Encuestador/getBanderaLink/',
      saveNPSCONTROL:'/api_empresa/savePreguntas/', // ES de prueba
      saveAdicionalesFocus: '/api_empresa/FocusArea/saveAdicionales/', // Prueba
      saveAdicionalesFocus2: '/api_empresa/FocusArea/saveAdicionales2/', // Prueba
      saveRecordatorios: '/api_empresa/saveRecordatorios/',
      deleteRecordatorio: '/api_empresa/deleteRecordatorio/',
      updateRecordatorios: '/api_empresa/updateRecordatorio/',
      deleteAvisos: '/api_empresa/deleteAvisos/',
      updateAvisos: '/api_empresa/updateAvisos/',

    },
    //APIS EnvioCorreo

    envioCorreo:{
      sendMail: '/api_empresa/MailSender/',
      getPilotoData: '/api_empresa/getPiloto/',
      //sendRecordatorioEmail35: 'api_empresa/Norma35/sendRecordatorio/',

    },
    //APIS Cierre
    cierre:{
      getAvanceEncuesta: '/api_empresa/getAvanceEncuesta/',

    },
    //APIS RequirementsService
    requirements:{
      responsableTI: '/api_empresa/responsableTI/',
    },
    //APIS RegisterUser
    registerUs:{
      getLevel: '/api_empresa/NivelesUsuario',
      getEnterprises:'/api_empresa/Empresas',
      registerUser: '/api_login/register',
    },

    //APIS LandingService
    landing:{
      getCertifyList:    '/api_empresa/Productos/all/',
    },
    //APIS ODSService
    ods:{
      getInstituteArray:'/api_empresa/Institutos/',
      getInstituteArrayV2:'/api_empresa/InstitutosV2/',
      getPlantillas:'/api_empresa/CatalogoPlantillas/',
      getEmail_Plantillas:'/api_empresa/templatesComunicacion/',
      getSectorarray:'/api_empresa/Sectores/',
      getRankingrray:'/api_empresa/Ranking/',
      getYearsArray:'/api_empresa/Anios/',
      getestilo: '/api_empresa/estilos/',
      getProductsByCompany:'/api_empresa/Productos/Actuales/',
      updateStatus:'/api_empresa/Certificar/secciones/update/',
      getRegiones:'/api_empresa/catalogoSalesForce/',

      updateODS: '/api_empresa/Empresa/update/',
      enviaEmail: '/api_empresa/Empresa/enviarCorreos/',
      consultarencuesta:'/api_empresa/ConsultarEncuestas/',

      getListaEmpresas: '/api_empresa/Empresas/get/',

      actualizarCA: '/api_empresa/ca/updateCA/',

    },
    //APIS AbiertasService
    abiertas:{
      insertaCatalogoAbiertas:'/api_empresa/saveAbiertasCatalogo/',
      getAbiertas:'/api_empresa/getAbiertas/',
      updateTraducciones:'/api_empresa/saveTraduccionAbierta/',
      getTraducciones: '/api_empresa/getTraduccionesAbiertas/',
      saveAbiertas: '/api_empresa/addAbierta/',
      updateAbiertas: '/api_empresa/updateAbierta/',
      deleteAbiertas: '/api_empresa/deleteAbierta/',
    },

    //APIS NPS service
    nps:{
      insertaCatalogoNps:'/api_empresa/saveNpsCatalogo/',
      getNps:'/api_empresa/getNps/',
      updateTraducciones:'/api_empresa/saveTraduccionNps/',
      getTraducciones: '/api_empresa/getTraduccionesNps/',
      updateNps: '/api_empresa/updateNps/',
    },

    //APIS CONTROL service
    control:{
      insertaCatalogoControl:'/api_empresa/saveControlCatalogo/',
      getControl:'/api_empresa/getControl/',
      updateTraducciones:'/api_empresa/saveTraduccionControl/',
      getTraducciones: '/api_empresa/getTraduccionesControl/',
      updateControl: '/api_empresa/updateControl/',
    },

    //APIS ReactivosService
    reactivos:{
      insertaCatalogoReactivos:'/api_empresa/saveReactivosCatalogo/',
      saveReactivo: '/api_empresa/addReactivo/',
      getTraducciones: '/api_empresa/getTraduccionesReactivos/',
      updateTraducciones:'/api_empresa/saveTraduccionReactivo/',
      updateReactivo:'/api_empresa/updateReactivo/',
      deleteReactivo:'/api_empresa/deleteReactivo/',
      getReactivos: '/api_empresa/getReactivos/'
    },

    // Task
    deletetareaPrimaria: '/api_empresa/Documentador/Tareas/delete/',

    // Primary Task
    SavePrimaryTask: '/api_empresa/Documentador/Guardar/TareaSecundaria/',
    GetAllPrimaryTask: '/api_empresa/Documentador/Tareas/all/',
    UploadPrimaryTaskFile: '/api_empresa/Documentador/Tareas/archivo/upload/',
    UpdatePrimaryFile:'/api_empresa/Documentador/Tareas/archivo/update/',
    GetUploadPrimaryTaskFile: '/api_empresa/Documentador/Tareas/archivos/',
    // DeletePrimaryTaskFile: '/api_empresa/Documentador/Tareas/archivo/delete/',
    GetPrimaryTodoList: '/api_empresa/Documentador/toDoList/',
    DeleteprimaryFile: '/api_empresa/Documentador/Tareas/archivo/delete/',
    //Secondary task
    DataSaveTask: '/api_empresa/Documentador/Guardar/Tarea/',
    GetTask: '/api_empresa/Documentador/Tareas/get/',
    RemoveTask: '/api_empresa/Documentador/Borrar/Tarea/',
    //quitar
    // GetOnlyTask: '/api_empresa/Documentador/Tareas/get/',
    GetAllTask: '/api_empresa/Documentador/Tareas/',
    //Files
    SaveFiles: '/api_empresa/Documentador/archivo/upload/',
    GetAllFile: '/api_empresa/Documentador/archivos/',
    DeleteFile: '/api_empresa/Documentador/archivo/delete/',
    // ENCUESTADOR NORMA 35
    RegistarFecha: '/api_empresa/Norma35/programarEncuesta/',
    RegistrarRecordatorio: '/api_empresa/Norma35/programarEncuesta/recordatorios/',
    saveRecordatorio:'/api_empresa/Norma35/programarEncuesta/saveRecordatorio/',
    getfecha35:'/api_empresa/Norma35/programarEncuesta/fechaLanzamiento/',
    saveDateLanzV2:'/api_empresa/Norma35/programarEncuesta2/',
    getDateLanzV2:'/api_empresa/Norma35/programacionEncuesta/',
    // //quitar
    // getRecordatoriosEnc:'/api_empresa/Norma35/programarEncuesta/recordatorios/',

    //Excel
    GuardarColaboradores35 : '/api_empresa/Norma35/Colaboradores/',
    GetColaboradores35 : '/api_empresa/Norma35/Colaboradores/get/',
    borrarColaboradores35: '/api_empresa/Norma35/Colaboradores/delete/',

    //Centros de trabajo
    GetCentro35 : '/api_empresa/Norma35/CentrosTrabajo/get/',
    GuardarCentro35 : '/api_empresa/Norma35/CentrosTrabajo/',
    borrarCentros35: '/api_empresa/Norma35/CentrosTrabajo/delete/',
    infoCentros: '/api_empresa/Norma35/CentrosTrabajo/getInfo/',

    expedientes:{ // Parte norma35
      getColaboradores:'/api_empresa/Norma35/Colaboradores/download/',
      getPersonasAyuda:'/api_empresa/Norma35/getColaboradoresNeed/',
      getAllPersonasAyuda:'/api_empresa/Norma35/getColaboradoresNeed/all/',
      //getColaboradores:'/api_empresa/Norma35/Colaboradores/download/',
      savedoctors:'/api_empresa/Norma35/saveDoctor/',
      getMedicos:'/api_empresa/Norma35/Doctores/',
      deleteMedicos:'/api_empresa/Norma35/Doctor/',
      savekey: '/api_empresa/saveClave',
      getkey:'/api_empresa/getClaveEmpresa',
      getAllkey:'/api_empresa/getClaves',
    },
    doctores:{
      getDoctor:'/api_empresa/Norma35/Doctor/',
      saveDate:'/api_empresa/Norma35/saveCita',
      getAlldoctordates:'/api_empresa/Norma35/Citas/',
      getCitaColaborador:'/api_empresa/Norma35/Colaborador/Citas/',
    },
    wizardEnc:{
      getAllstatus:'/api_empresa/Norma35/estatus/get/',
      getStatus:'/api_empresa/Norma35/estatus/paso/',
      sendStatus:'/api_empresa/Norma35/estatus/update/'
    },

    //RESULTADOS NORMA35
    resultadosN35:{
      datosEmpresa:'/api_empresa/Empresas/',
      logoEempresa:'/api_empresa/logo2/get/',
      centrosDeTrabajo:'/api_empresa/Norma35/CentrosTrabajo/getInfoCT/',
      datosGeneralesCT:'/api_empresa/Norma35/resultadosGenerales/',
      resultadosTablero:'/api_empresa/Norma35/resultadosTablero/',
      respuestasEncuesta:'/api_empresa/Norma35/respuestasEncuesta/',
      respuestasEncuestaFactores:'/api_empresa/Norma35/factoresRiesgo/',
      descargarResultados:'/api_empresa/Norma35/resultadosIndividuales/',
    },


    // PROGRAMAR ENCUESTA NORMA35
    savetableColaboradores:'/api_empresa/Norma35/Evidencias/upload/',
    movetableColaboradores:'/api_empresa/Norma35/Evidencias/get/',
    deleteFileExp:'/api_empresa/Norma35/Evidencias/delete/',
    crearencuesta35:'/api_empresa/Norma35/crearEncuesta/',
    encuestamas50: '/api_empresa/Norma35/savePreguntasMas50/',
    encuestamenos50: '/api_empresa/Norma35/savePreguntasMenos50/',
    sendUsers35:'/api_empresa/Norma35/saveUsuarios/',
    getPilot:'/api_empresa/Norma35/getPiloto/',
    sendemails35:'/api_empresa/Norma35/enviarCorreos/', // Envio de correos
    sendRecordatorioEmail35: '/api_empresa/Norma35/sendRecordatorio/',//Recordatorio manuales para la nom
    getRecordatorioManual35: '/api_empresa/Norma35/getRecordatorio/', // Get de recordatorios manuales
    getStatus_correos:'/api_empresa/Norma35/getBanderaCorreos/', //Bandera para saber si se han enviado los correos
    getBanderaVideo: '/api_empresa/getBanderaVideo/',
    setBanderaVideo: '/api_empresa/updateBanderaVideo/',
    pilotmails:'/api_empresa/Norma35/MailSenderPreview/', // 5 correos pilotos
    getsurveyclose:'/api_empresa/Norma35/getAvanceEncuesta/',
    sendCheck:'/api_empresa/Norma35/mailDocumentador/',
    getChecked:'/api_empresa/Norma35/getMailDocumentador/',


    getFiltrosConteo: '/api_empresa/getFiltros',
    ///Conteos Certificar
    getConteosFiltros:'/api_empresa/getConteos/',
    getConteosFiltrosNuevaVersion:'/api_empresa/coutingPortal/',
    getConteosExcelVersionReducida:'/api_empresa/coutingPortalV2/',
    getConteosFiltrosNuevaVersionExterna:'/api_empresa/coutingPortal3/',
    ///Conteos Medir
    getConteosFiltrosMedir: '/api_empresa/Medir/getConteos/',
    getConteosFiltrosPulse:'/api_empresa/PulseCheck/getConteos/',
    getConteosFiltrosFocusArea:'/api_empresa/FocusArea/getConteos/',

    filtroNorma35:'/api_empresa/Norma35/getFiltros',
    getConteos35:'/api_empresa/Norma35/getConteos/',

    ////Portal Conteos  Externo
    saveConteosClave:'/api_empresa/saveClave/',//Generas clave
    getConteosClave:'/api_empresa/getClave/',
    getClaveConteo:'/api_empresa/getClaveEmpresa/',

    //Claves PulseCheck
    getClavesConteosPulse:'/api_empresa/getClaves/', //Recuperar claves

    ////Time line Graficas
    getGraficaCertificar: '/api_empresa/getTimeline/',
    getGraficaMedir: '/api_empresa/Medir/getTimeline/',
    getGraficaPulse: '/api_empresa/PulseCheck/getTimeline/',
    getGraficaNorma35:'/api_empresa/Norma35/getTimeline/',
    getGraficaFocusArea:'/api_empresa/FocusArea/getTimeline/',
    getDescargaExcelCertificar:'/api_empresa/getInfoGeneral/',
    getDescargaExcelMedir:'/api_empresa/Medir/getInfoGeneral/',
    getDescargaExcelPulse:'/api_empresa/PulseCheck/getInfoGeneral/',
    getDescargaExcelFocus:'/api_empresa/FocusArea/getInfoGeneral/',


    resul4all:{
      getresult4all:'/api_empresa/getResultadosForall/',
      getresultallProducVer3:'/api_empresa/getResultadosForall_v2/',

    },
    aditoriaAtoumatizada:{
      getMenos10Min:'/api_empresa/consultarTiempo/',
      getMuestrasMenos10Min:'/api_empresa/getMuestras/',
      crearMuestrasMenos10Min:'/api_empresa/generarMuestra/',
      editarComentario:'/api_empresa/saveComentario/',

    },
    //BUSQUEDA DE USUARIOS POR EMPRESA
    getUsuariosEmpresas:'/api_empresa/usuarios/',
    getUsuariosEmpresasGPTW:'/api_empresa/usuarios/instituto/',
    actualizaInfoUsuarioEmpresa:'/api_empresa/usuarios/actualizar/',
    deleteUsuariosAdmin:'/api_empresa/usuarios/deleted/',

    //NUEVO SERVICIO CA 5.0
    getCultureAudit:'/api_empresa/ca/IniciarCA/',
    fechaCierre:{
      updateFechaCierreUsuario:'/api_empresa/updateSurvey/endDate/',
      saveFechaProrroga:'/api_empresa/saveProrroga/',
      getProrrogasFechaEncuesta:'/api_empresa/getProrrogas/',
      cerrarEncuesta:'/api_empresa/updateSurveyStatus/',
      getStatusEncuesta:'/api_empresa/surveyStatus/',
      surveyClose: '/api_empresa/surveyClose/'
    },
    //SINCRONIZAR CON PORTAL DE CONTEOS
    sincronizar:'/api_empresa/generarTabla',

    //SERVICIOS DE SUPPORT A CGO
    //LOG SISTEMA CGO
    log:'/api_empresa/getLogs/',

    //LOG DE SENDGRIND
    getUsuarios:'/api_empresa/consultarColaboradores/',
    getStatusEmail:'/api_empresa/getLogIndiv',
    getIdiomas:'/api_empresa/Idiomas/get/',
    getIdiomasMedir:'/api_empresa/Medir/Idiomas/get/',
    getIdiomasProdPulse:'/api_empresa/PulseCheck/Idiomas/get/',
    getUsuariosFilter:'/api_empresa/consultarColaboradores/',

    //ELIMINAR EMPRESAS
    deleteCompany:'/api_empresa/Empresa/delete/',
    //TERMINA SERVICIOS DE SUPPORT A CGO

    surveyCheck:'/api_empresa/surveyCheck/',

    desbloqueoPasos:{
      activarFuncion:'/api_empresa/setDesbloqueoPasos/',
      consultarStatus:'/api_empresa/getDesbloqueoPasos/',
    },
    mostrarResultCerPort:{
         consultarStatus: '/api_empresa/getResultsBox/',
         updateactidesFuncion: '/api_empresa/updateResultsBox/',
     },

   historialesCer3:{
    getHistorialColActCrea:'/api_empresa/Colaboradores/getHistorial/',

  },
  requerimientosTecnicosv3:{
    getBanderaRequerimientoTecnicos:'/api_empresa/getFlagsConfig/',
    setBanderaRequerimientoTecnicos:'/api_empresa/setFlagsConfig/',
    // saveCuestionarioRT:'/api_empresa/CuestionarioRT/save/',
    // getCuestionarioRT:'/api_empresa/CuestionarioRT/get/',
    envioCorreoPrueba:'/api_empresa/searchUserSurvey/',
    getUserSurveyRequerimientosTecnicos:'/api_empresa/UserSurvey/get/',
    saveUserSurveyRequerimientosTecnicos:'/api_empresa/UserSurvey/save/',
    getBanderasDominios:'/api_empresa/getFlagDomainsRT/',
    updateBanderasDominios:'/api_empresa/updateFlagDomainsRT/',

    ////////requerimientosTecnicosv3 externo////////
    getBanderaRequerimientoTecnicosExterno:'/api_empresa/getRequirementsV3/',
    setBanderaRequerimientoTecnicosExterno:'/api_empresa/setRequirementsV3/',
    getCatalogoPreguntas:'/api_empresa/catQuestionnaire/get/',
    getCatalogoPreguntasAll:'/api_empresa/catQuestionnaire/getAll/',
    savePreguntas:'/api_empresa/catQuestionnaire/save/',
    envioCorreoPruebaExterno:'/api_empresa/searchUserSurveyExt/',
    sendEmailRequerimientosTecnicos:'/api_empresa/sendMailTI/',
    actualizaBanderaTestEmail:'/api_empresa/flagMailRequirementsV3/',
    getBanderasDominiosExternal:'/api_empresa/getFlagDomainsRTExternal/',
    updateBanderasDominiosExternal:'/api_empresa/updateFlagDomainsRTExternal/',

    getFormTI: '/RTform/Get/',
    saveFormTI: '/RTform/Save',
  },

  logSengridEmailStatus:{

    getAllGlobalEmailStatus:'/api_sendgrid/getAllDataWeebHook/',
    getInfoEventIndivEmail:'/api_sendgrid/getDataForCollaborator/',
    getInfoEventGralColabEmail:'/api_sendgrid/getStatusEmailsColaborador/',
    getLogStatusEmailColab:'/api_sendgrid/getLogStatusEmail',


  }



 }
};
